var EmailIdentificationEnum = /* @__PURE__ */ ((EmailIdentificationEnum2) => {
  EmailIdentificationEnum2["EMAIL_IDENTIFICATION_FORM"] = "email-identification--form";
  EmailIdentificationEnum2["EMAIL_IDENTIFICATION_INPUT_EMAIL"] = "email-identification--input-email";
  EmailIdentificationEnum2["EMAIL_IDENTIFICATION_SUBMIT_BUTTON"] = "email-identification--submit-button";
  EmailIdentificationEnum2["EMAIL_IDENTIFICATION_TERMS_LINK"] = "email-identification--terms-link";
  EmailIdentificationEnum2["EMAIL_IDENTIFICATION_PRIVACY_POLICY_LINK"] = "email-identification--privacy-policy-link";
  return EmailIdentificationEnum2;
})(EmailIdentificationEnum || {});
export {
  EmailIdentificationEnum
};
